export default {
    feature: {
        'birth-chart': {
            title: 'Mapa Astral Completo',
            text: 'Tenha acesso à <strong>informações exclusivas</strong> sobre o seu mapa astral.'
        },
        
         'compatibility': {
            title: 'Sinastria',
            text: 'Leia tudo sobre a <strong>compatibilidade astral</strong> entre você e as pessoas do seu interesse.'
        },
        
         'extra': {
            title: 'Mapas Extras',
            text: 'Leia o mapa astral completo de todas as <strong>pessoas ao seu redor</strong>.'
        },
        
        'horoscope-future': {
            title: 'Horóscopo Futuro',
            text: 'Veja <strong>com antecedência</strong> os trânsitos que influenciarão você no futuro.'
        },
        
         'tarot': {
            title: 'Tarot',
            text: 'Faça <strong>consultas ilimitadas</strong> e saiba o que as cartas têm a te dizer.'
        },
        
        'horoscope-extra': {
            title: 'Horóscopo de outras pessoas',
            text: 'Acompanhe o horóscopo e saiba quais são as influências ativas dos <strong>seus contatos.</strong>'
        },
        
         'visits': {
            title: 'Quem te visitou',
            text: 'Saiba quem são todas as <strong>pessoas que visitam o seu perfil</strong>.'
        },
        
         'people': {
            title: 'Quem te curtiu',
            text: 'Veja quem são as pessoas que <strong>demonstram interesse por você.</strong>'
        },
        
        'moon-phases': {
            title: 'Ciclo Lunar',
            text: 'Informações sobre as <strong>fases da lua</strong> e dicas de suas <strong>influências</strong>.'
        }
    }
};